module.exports = __webpack_public_path__ + "static/img/banner_index.86bc427a.png";